import React from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '../button';

import type { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

export type Props = {
  bodyText?: string;
  buttonIcon?: IconProp;
  buttonText?: string;
  buttonType?: string;
  children?: React.ReactNode;
  className?: string;
  header?: string;
  icon?: IconProp;
  iconRaw?: boolean;
  iconSize?: SizeProp;
  plainButton?: boolean;
  style?: React.CSSProperties;
  variant?: 'inline';
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function EmptyState({
  bodyText,
  buttonIcon,
  buttonText,
  buttonType,
  children,
  className,
  header,
  icon,
  iconRaw,
  iconSize,
  plainButton = true,
  style,
  variant,
  onClick,
}: Props) {
  const buttonProps = {
    icon: buttonIcon,
    label: buttonText,
    plain: false,
    type: buttonType,
    onClick,
  };

  if (plainButton) {
    buttonProps.plain = true;
  }

  return (
    <div
      className={classNames('empty bg-white', className, { [`empty-${variant}`]: variant })}
      style={style || {}}
    >
      {icon &&
        <div className="empty-media">
          {iconRaw ? icon :
            <FontAwesomeIcon
              className="icon-gradient"
              icon={icon}
              size={iconSize}
            />
          }
        </div>
      }
      <div className="empty-content">
        {header ? (
          <h3 className="empty-title">
            <strong>{header}</strong>
          </h3>
        ) : null}
        {bodyText ? <div className="">{bodyText}</div> : null}
      </div>
      {(buttonText || children) &&
        <div className="empty-actions">
          {buttonText && onClick ? <Button.Primary {...buttonProps} /> : null}
          {children}
        </div>
      }
    </div>
  );
}
